export const INPUT_NAMES = {
  CARD_HOLDER: 'cardHolder',
  CARD_NUMBER: 'cardNumber',
  MMYY: 'mmyy',
  CVC: 'cvc',
  ZIP_CODE: 'zipCode',
};
